'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import MarkdownContent from '@/components/Think/MarkdownContent';
import MessageChart from '@/components/Message/MessageChart';
import { DeepThinkStatus } from '@/type/chat';
import { FileCheck } from 'lucide-react';

interface StepContentProps {
  parsedData: any;
  step?: DeepThinkStatus;
}

const StepContent: React.FC<StepContentProps> = ({ parsedData, step }) => {
  if (!parsedData) return null;

  return (
    <div className="mb-2">
      {(parsedData?.detail || parsedData?.results) && (
        <div className="flex items-center gap-2 text-sm mb-4 -ml-8">
          <FileCheck size={16} /> Results
        </div>
      )}
      {/* Markdown detail content */}
      {parsedData?.detail && <MarkdownContent content={parsedData.detail} />}

      {/* Results content */}
      {parsedData?.results && (
        <div className={cn('mt-1 w-full', parsedData?.detail && 'pt-1')}>
          {/* Table visualization */}
          {parsedData?.visualizationType === 'echarts' ? (
            <MessageChart chartConfig={parsedData?.results} step={step as any} className="my-2!" />
          ) : (
            <MarkdownContent content={parsedData?.results} />
          )}
        </div>
      )}
    </div>
  );
};

export default StepContent;
